import PrimaryBtn from '../component/btn/PrimaryBtn'
import FeaturesSlider from '../component/slider/FeaturesSlider'
import FeaturesComp from '../component/FeaturesComp'
import BannerSlider from '../component/BannerSlider'
import RBannerSlider from '../component/RBannerSlider'
import features02 from '../images/features02.png'
import features03 from '../images/features03.png'
import features04 from '../images/features04.png'
import { Helmet } from 'react-helmet'
import Cta from '../component/Cta'
import Client from '../component/Client'
import MainTestimonial from "../component/slider/MainTestimonial" 
export default function Features() {
  return (
    <div>
        <Helmet>
            <title>ParcelX - Features</title>
        </Helmet>
        <section className='section01'>
            <div className='container-fluid'>
                <div className='col-md-11 mx-auto'>
                    <div className='row'>
                        <div className='col-md-10'>
                            <h2 className='heading'>Use <span>one platform</span> for all of your <br /> e-commerce shipping needs</h2>
                            <ul className='features-point'>
                                <li><i className='fas fa-check'></i> Track all shipping analytics in one place</li>
                                <li><i className='fas fa-check'></i> 29,000+ Serviceable Pincodes & 20+ Courier Partners </li>
                                <li><i className='fas fa-check'></i> No Subscription Fees</li>
                            </ul>
                            <PrimaryBtn text="Get Started" href="https://seller.parcelx.in/register" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <FeaturesSlider />
        <section className="section04">
            <div className="container-fluid">
                <div className="col-md-11 mx-auto">
                <h2 className="heading"><span>Our Features:</span> Passion for Logistics & Ecom Shipping</h2>
                <p>ParcelX is one of the “one of the fastest-growing end-to-end logistics aggregators end-to-end logistics aggregators. With deep domain expertise and automated solutions, we strive to become the best virtual logistics arm.</p>
                </div>
                <FeaturesComp />
            </div>
        </section>
        <BannerSlider />
        <RBannerSlider />
        <section className="section04">
            <div className="container-fluid">
                <div className="col-md-11 mx-auto">
                    <div className='row align-items-center'>
                        <div className='col-md-5 order-md-2 text-md-right mb-3'>
                            <img src={features04} className='img-fluid'/>
                        </div>
                        <div className='col-md-7 mb-3'>
                            <h2 className='heading'><span>NDR Management:</span> Customer unavailable? No problem.</h2>
                            <p>Is the customer unavailable for delivery? ParcelX's NDR (Non-Delivery Report) management system ensures your parcel still reaches its destination. We initiate multiple re-delivery attempts and keep you We keep you updated every step of the way. Our dedicated NDR calling team will also reach out to resolve issues and ensure successful delivery.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="section04">
            <div className="container-fluid">
                <div className="col-md-11 mx-auto">
                    <div className='row align-items-center'>
                        <div className='col-md-5 mb-3'>
                            <img src={features03} className='img-fluid'/>
                        </div>
                        <div className='col-md-7 mb-3'>
                            <h2 className='heading'><span>Billing Weight Reconciliation:</span> we’ll do the hard work for you.</h2>
                            <p>Ensuring fair and accurate billing is crucial. ParcelX takes the burden of billing discrepancies off your shoulders If you're not satisfied with the weight charged, our dedicated team will diligently work to reconcile the billing weight for you, by comparing actual and dimensional weights to ensure you're only paying what's accurate</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="section04">
            <div className="container-fluid">
                <div className="col-md-11 mx-auto">
                    <div className='row align-items-center'>
                        <div className='col-md-5 order-md-2 text-md-right mb-3'>
                            <img src={features02} className='img-fluid'/>
                        </div>
                        <div className='col-md-7 mb-3'>
                            <h2 className='heading'><span>Timely COD Remittance:</span> We know how important money is.</h2>
                            <p>At ParcelX, we understand the critical importance of a healthy cash flow for your business. That's why we prioritize timely COD remittance. With our efficient systems, you won't have to endure long waiting periods for your Cash on Delivery payments to reach your bank account, ensuring you have swift access to your funds for seamless operations and continued growth.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Client />
        <MainTestimonial />
        <Cta />
    </div>
  )
}
